import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Header from '../../main/components/Header';
import MobileBottomBar from '../../main/components/MobileBottomBar';
import Path from '../../path/ui/Path';
import EditForm from '../components/EditForm';
import getAnnouncementById from '../../../api/getAnnouncementById';
import Loading from '../../../common/components/Loading';

function Main() {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [announcementId] = useState(location.state?.adId || null);
    const [announcementData, setAnnouncementData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!announcementId) { navigate('/profile#ads', { replace: true }); return; }
        getAnnouncementById(announcementId)
            .then(data => setAnnouncementData(data.announcement))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, [announcementId, navigate]);

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <Header />
            <Path currentPath={t('editAnnouncement')} pathTo="/profile#ads" />

            <div className="flex-1 px-4 md:px-[60px] lg:px-[120px] xl:px-[200px] py-6 pb-24 md:pb-8">
                {loading ? (
                    <div className="flex justify-center py-20"><Loading /></div>
                ) : announcementData ? (
                    <EditForm announcementId={announcementId} announcementData={announcementData} />
                ) : (
                    <p className="text-center text-gray-400 py-20">{t('no_nothing')}</p>
                )}
            </div>

            <MobileBottomBar />
        </div>
    );
}

export default Main;
